import { render, staticRenderFns } from "./SubOne.vue?vue&type=template&id=47234974&scoped=true&"
import script from "./SubOne.vue?vue&type=script&lang=js&"
export * from "./SubOne.vue?vue&type=script&lang=js&"
import style0 from "./SubOne.vue?vue&type=style&index=0&id=47234974&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47234974",
  null
  
)

export default component.exports